<template>
  <div>
    <my-notification :icon="'times'" :type="'error'" v-if="erreur">
      <template #title> Erreur </template>
      <div>
        L'erreur suivante est survenue sur le serveur pendant le traitement de
        votre demande :
        <ul style="list-style-type: square; margin-left: 25px">
          <li>« {{ erreur }} »</li>
        </ul>
        Si ce problème persiste, veuillez
        <router-link class="link" to="/">nous contacter</router-link>.
      </div>
    </my-notification>
    <br v-if="erreur" />
  </div>
</template>

<script>
export default {
  name: 'ServeurInfo',
  props: {
    erreur: {
      type: String,
      default: ''
    }
  },
  components: {
    'my-notification': () => import('@/components/MyNotification.vue')
  }
}
</script>
